import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b51d2cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "player" }
const _hoisted_4 = { class: "user-icon-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vs" }, "VS", -1))
const _hoisted_6 = { class: "player" }
const _hoisted_7 = { class: "user-icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ final: _ctx.isFinals }, "tournament-card"])
  }, [
    _createElementVNode("div", _hoisted_1, "Game " + _toDisplayString(_ctx.match.status), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.match.winner === _ctx.playerOne.id)
            ? (_openBlock(), _createBlock(_component_fa_icon, {
                key: 0,
                icon: "tree",
                color: "#ff8e01"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_fa_icon, {
            icon: "getPlayerIcon(playerOne)",
            color: _ctx.playerOne.icon.color,
            size: "3x"
          }, null, 8, ["color"])
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.playerOne.name), 1)
      ]),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.match.winner === _ctx.playerTwo.id)
            ? (_openBlock(), _createBlock(_component_fa_icon, {
                key: 0,
                icon: "tree",
                color: "#ff8e01"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_fa_icon, {
            icon: "getPlayerIcon(playerTwo)",
            color: _ctx.playerTwo.icon.color,
            size: "3x"
          }, null, 8, ["color"])
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.playerTwo.name), 1)
      ])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}